export default __webpack_public_path__ + "static/media/img14.da0cffce.jpg";